import CtaName from '../interfaces/ctaName';

const navigationFooterLabels: CtaName = {
  BACK: 'BACK',
  LETS_BEGIN: "LET'S BEGIN",
  SUBMIT: 'SUBMIT',
  NEXT: 'NEXT',
};

export default navigationFooterLabels;
